<template>
  <div>
    <!-- <b-row>
      <b-col class="col-md-2">
        <AppSearchInput
          v-model="filter.search"
          :label="$t('search') + ':'"
          :placeholder="$t('search') + '...'"
          @callback="onFilter"
        />
      </b-col>
      <b-col class="col-md-2">
        <b-form-group
          label="Фильтр по объекты"
        >
          <v-select
            v-model="filter.object"
            class="bg-white rounded"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="title"
            :reduce="(p)=>p.id"
            :options="[]"
            @input="onFilter"
          />
        </b-form-group>
      </b-col>
      <b-col class="col-md-2">
        <b-form-group
          :label="$t('filter_by_status')"
        >
          <v-select
            v-model="filter.status"
            class="bg-white rounded"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="name"
            :options="ptoStatesMini"
            :reduce="(a)=>a.id"
            @input="onFilter"
          />
        </b-form-group>
      </b-col>
    </b-row> -->
    <!-- <b-card > -->
    <b-table
      v-if="!isLoading"
      id="user-table"
      class="px-1 rounded mt-1 bg-light-secondary"
      :items="GET_PTO_FOR_GOOD_LIST.results"
      :fields="fields"
      show-empty
      :tbody-tr-class="['tableRowClass']"
      small
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
  

      <template #cell(author)="props">
        <div>
          <span
            v-if="
              props.item.author &&
              (props.item.author.first_name || props.item.author.last_name)
            "
            >{{ props.item.author.first_name }}
            {{ props.item.author.last_name }}</span
          >
        </div>
      </template>

      <template #cell(actions)="props">
        <div class="d-flex align-items-center justify-content-center">
          <b-button
            class="mr-1 mt-50 mb-50"
            v-b-tooltip.hover.v-primary
            title="Просмотр"
            size="sm"
            variant="primary"
            v-b-toggle.task-datail
            @click="onClickView(props.item.id)"
          >
            <feather-icon icon="ChevronsRightIcon" size="15" />
          </b-button>

          <template v-for="(item, index) in props.item.status.change_to">
            <b-button
              :key="index"
              class="mr-1 ml-50 mt-50 mb-50"
              v-b-tooltip.hover.v-primary
              size="sm"
              style="margin: 3px 0"
              v-if="checkButtonPermission([...item.roles, 'admin'])"
              :variant="item.color"
              @click="onChangeStatus(props.item, item)"
              :disabled="detect(props.item, item)"
            >
              {{ item.name }}
            </b-button>
          </template>
        </div>
      </template>
    </b-table>

    <b-card v-else>
      <Loader />
    </b-card>

    <Pagination
      @refresh="refresh"
      :rows="GET_PTO_FOR_GOOD_LIST.count"
      :params="filter"
    />
    <TaskDetailSidebar :loading="loading" @refresh="refresh" />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BButton,
  BFormGroup,
  BBadge,
  VBTooltip,
  VBToggle,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import { mapActions, mapGetters, mapState } from "vuex";
import AppSearchInput from "@/components/AppSearchInput.vue";
import Pagination from "@/components/Pagination.vue";
import check from "@/mixins/check";
import formmatter from "@/mixins/formmatter";
import TaskDetailSidebar from "./components/PtoFileSidebar.vue";
import loader from "@/mixins/loader";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BButton,
    Loader,
    AppSearchInput,
    vSelect,
    BFormGroup,
    BBadge,
    Pagination,
    TaskDetailSidebar,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
    Ripple,
    "b-toggle": VBToggle,
  },
  mixins: [check, formmatter, loader],
  data() {
    return {
      isLoading: false,
      loading: false,
      filter: {
        page: 1,
        page_size: 10,
      },
      option: [],
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "courses.type",
          key: "material.goods.product.title",
          thClass: "tableHeadClass",
        },
        {
          label: "product",
          key: "material.goods.value",
          thClass: "tableHeadClass",
        },
        {
          label: "unit_of_measurement",
          key: "material.goods.unity",
          thClass: "tableHeadClass",
        },
        {
          label: "amount",
          key: "quantity",
          thClass: "tableHeadClass",
        },
        {
          label: "object",
          key: "rc_object",
          thClass: "tableHeadClass",
        },
        {
          label: "date",
          key: "created_at",
          formatter: (data) => this.$dayjs(data).format("DD.MM.YYYY"),
          thClass: "tableHeadClass",
        },
        {
          label: "master",
          key: "author",
          thClass: "tableHeadClass",
        },
        {
          label: "note",
          key: "material.note",
          thClass: "tableHeadClass",
        },
        {
          label: "сontract_number",
          key: "material.contract_number",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
    };
  },
  computed: {
    ...mapGetters("pto", ["GET_PTO_FOR_GOOD_LIST"]),
    ...mapState("pto", ["ptoStatesMini"]),
  },
  async mounted() {
    this.isLoading = true;
    await this.FETCH_PTO_FOR_GOOD_LIST(this.filter);
    this.isLoading = false;
  },
  methods: {
    ...mapActions("pto", [
      "FETCH_PTO_FOR_GOOD_LIST",
      "UPDATE_PTO_FOR_GOOD",
      "FETCH_PTO_FOR_GOOD_ONE",
      "FETCH_KNOWLEDGE_BASE_STATUSES_MINI",
    ]),

    async refresh() {
      this.isLoading = true;
      await this.FETCH_PTO_FOR_GOOD_LIST(this.filter);
      this.isLoading = false;
    },

    detect(data, item) {
      if (item.unique_name == "confirmation_pto") {
        if (data.comments.length == 0 || data.photos.length == 0) {
          return true;
        }
      }
    },
    onChangeStatus(props, item) {
      const status = {
        confirmation_pto: this.$t('PTO_confirmed_write-off'),
        denied_pto: this.$t('go_to_refused_status'),
      };
      this.$bvModal
        .msgBoxConfirm(
          this.$t('do_you_really_want') + ` ${status[item.unique_name]} ?`,
          {
            title: this.$i18n.t("attention"),
            size: "sm",
            okVariant: item.color,
            okTitle: this.$t("yes"),
            cancelTitle: this.$t("no"),
            cancelVariant: "outline-secondary",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then(async (value) => {
          if (!value) return;
          await this.UPDATE_PTO_FOR_GOOD({
            status_unique: item.unique_name,
            id: props.id,
          })
            .then(() => {
              this.$_okToast();
              this.FETCH_PTO_FOR_GOOD_LIST(this.filter);
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        });
    },
    onClickView(id) {
      this.FETCH_PTO_FOR_GOOD_ONE(id);
    },
    onFilter() {
      this.FETCH_PTO_FOR_GOOD_LIST(this.filter);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}
</style>
